import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import SocialLinks from "../SocialLinks";
import PageSEO from "../../utils/PageSEO";
import { useTranslation } from "../../i18n";

function Home() {
  const { t } = useTranslation();

  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Yuvasree Padmanabhan",
    "jobTitle": "Automation Engineer / Aspiring Software Engineer",
    "url": "https://yuvasree.online",
    "image": "https://yuvasree.online/og-image.png",
    "sameAs": [
      "https://github.com/Yuvasreepadmanaban",
      "https://www.linkedin.com/in/yuvasree-padmanabhan/"
    ],
    "email": "yuvasreepadmanabhan@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Chennai",
      "addressCountry": "IN"
    }
  };

  return (
    <>
      <PageSEO
        title="Yuvasree Padmanabhan | Full Stack Developer & Automation Engineer | Portfolio"
        description="Full Stack Developer and Automation Engineer portfolio. Explore projects, experience, certifications, and career journey from Automation Engineer at Ncompass TechStudio to aspiring Software Engineer in Chennai, India."
        keywords="Yuvasree Padmanabhan, portfolio, full stack developer, software engineer, automation engineer, React developer, Node.js, web development, Chennai, India"
        url="https://yuvasree.online/"
        structuredData={homeStructuredData}
      />
      <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="home-hero-row">
            <Col xs={12} md={7} className="home-header">
              <h1 className="heading">{t("home.greeting")} </h1>

              <h1 className="heading-name">
                {t("home.im")}
                <strong className="main-name"> {t("home.name")}</strong>
              </h1>

              <div className="home-typewriter-wrapper">
                <Type />
              </div>
            </Col>

            <Col xs={12} md={5} className="home-hero-image-col">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid home-hero-image"
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>{t("home.findMeOn")}</h1>
            <p>
              {t("home.connectPrefix")}{" "}
              <span className="purple">{t("home.connectHighlight")}</span>{" "}
              {t("home.connectSuffix")}
            </p>
            <ul className="home-about-social-links">
              <SocialLinks />
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
}

export default Home;
